import { styled, css } from '@mui/material/styles';

const StyledWrapper = styled('div')`
  padding: 20px 0 200px;
  .wrapper {
    display: flex;
    gap: 1rem;

    .user-info {
      width: 30%;
      background: #fff;
      border-radius: 6px;
      padding: 39px 14px 32px 14px;
      height: 340px;

      .top {
        border-bottom: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        align-items: center;

        h3 {
          color: #000;
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin: 24px 0 12px;
        }

        p {
          color: #222;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
          margin-bottom: 30px;
        }
      }

      .btns {
        padding-top: 20px;
        border-top: 1px solid #ccc;
        display: flex;
        gap: 5px;
        justify-content: space-between;
        .btn-call {
          border-radius: 6px;
          border: 1px solid rgba(195, 17, 98, 0.2);
          background: #fff;
          color: #c31162;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          span {
            display: flex;
            align-items: center;
            gap: 10px;
          }
        }

        .btn-offer {
          border-radius: 6px;
          border: 1px solid rgba(12, 136, 198, 0.2);
          background: #fff;
          color: #0c88c6;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          span {
            display: flex;
            align-items: center;
            gap: 10px;
          }
        }
      }
    }

    .user-products {
      .top {
        display: flex;
      }
      width: 70%;
      background: #fff;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      h3.title {
        margin-top: 0;
        margin-bottom: 50px;
        color: #000;
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }

  @media (max-width: 991.98px) {
    .wrapper {
      flex-direction: column;

      .user-info {
        width: 100%;
      }

      .user-products {
        width: 100%;
        padding: 10px;
      }
    }
  }
`;

export default StyledWrapper;
